"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWarningAlert = exports.WarningAlert = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
const WarningAlert_1 = require("@reactionable/core/lib/ui/alert/WarningAlert");
const Alert_1 = require("./Alert");
const WarningAlert = (props) => {
    return jsx_runtime_1.jsx(Alert_1.Alert, Object.assign({ variant: "warning", icon: { icon: free_solid_svg_icons_1.faExclamationTriangle } }, props), void 0);
};
exports.WarningAlert = WarningAlert;
const useWarningAlert = (props) => {
    return WarningAlert_1.useWarningAlert(Object.assign({ Component: exports.WarningAlert }, props));
};
exports.useWarningAlert = useWarningAlert;
//# sourceMappingURL=WarningAlert.js.map